var React     = require("react");
var Reflux    = require('reflux');
var Actions   = require('advocate/challenges/actions');
var ExperiencesActions = require("advocate/challenges/actions/experiences_actions");
var _         = require("lodash");
import challengeUnlock from './components/challenge_unlock_notifier';

var ChallengeBrowserCollection = require('advocate/challenges/stores/challenge_browser_collection');
var RegularHeader              = require('advocate/challenges/components/regular_header');
var ExperienceHeader           = require('advocate/challenges/components/experience_header');
var { ChallengeCards }         = require('advocate/challenges/components/challenge_cards');
var NoChallenges               = require('advocate/challenges/components/no_challenges');
var ChallengesUnlocked         = require('advocate/challenges/components/challenges_unlocked');
var ChallengesLoading          = require('advocate/challenges/components/challenges_loading');
var ChallengeError             = require('advocate/challenges/components/challenge_error');
var ChallengeError             = require('advocate/challenges/components/challenge_error');

// Changing the layout requiring elements
var Filters = require('advocate/challenges/components/filters');

var animate                             = require("patternity/lib/utilities/animate");
var animateCardReshuffle                = require("advocate/challenges/animations/animate_card_reshuffle");
var { withNamespaces, I18nextProvider } = require('react-i18next');

import i18nInstance from '../../localization';

var ChallengeBrowser = React.createClass({
  mixins: [Reflux.connect(ChallengeBrowserCollection, "data")],
  PropTypes: {
    challengeTypes:        React.PropTypes.array.isRequired,
    experiences:           React.PropTypes.object.isRequired,
    channels:              React.PropTypes.object.isRequired,
    systemAvailability:    React.PropTypes.object.isRequired,
    viewChallenge:         React.PropTypes.object.isRequired,
    experiencePath:        React.PropTypes.string.isRequired,
    channelPath:           React.PropTypes.string.isRequired,
    advocateRewardsPath:   React.PropTypes.string.isRequired,
    editProfilePath:       React.PropTypes.string.isRequired,
    appNotificationCenter: React.PropTypes.object.isRequired,
    csrf_token:            React.PropTypes.string.isRequired,
    pageSize:              React.PropTypes.number.isRequired,
    pageThreshold:         React.PropTypes.number.isRequired,
    currentExperience:     React.PropTypes.shape({
      isSelected:          React.PropTypes.bool.isRequired,
      id:                  React.PropTypes.number.isRequired,
      name:                React.PropTypes.string.isRequired,
      description:         React.PropTypes.string.isRequired,
      image:               React.PropTypes.string.isRequired
    }).isRequired,
    currentChannel:       React.PropTypes.object,
    communityName:        React.PropTypes.string.isRequired,
    homepageUrl:          React.PropTypes.string.isRequired,
    channelId:            React.PropTypes.string,
    experienceReturnUrl:  React.PropTypes.string,
    shortCardDesignEnabled: React.PropTypes.bool,
  },

  getInitialState: function() {
    return {
      data : {
        challenges : [[]],
        challengeTypes : [],
        experiences : [],
        channels : [],
        channel : {},
        hasMoreChallenges : false,
        loadingChallenges : true,
        errors : null,
        challengeStatusDescription : {
          challengeId : "",
          status: "",
          statusDescription : ""
        },
        challengeListLoaded : false
      },
      selectedTabIndex : 0,
      selectedTabName: window._infl.hub.features.includes('mountain_dew') ? "whatsnew" : "available",
      selectedChallengeFilter : {
        type: "",
        sort:   ""
      },
      showExperienceUnlocked : false,
      unlockedChallenges : []
    };
  },

  componentWillMount : function(){
    Actions.setPageSize(this.props.pageSize);
    Actions.setChannelId(this.props.channelId);
    Actions.setCurrentChannel(this.props.currentChannel);

    challengeUnlock.reset();

    this._fetchChallenges("fetchAvailableChallenges");

    if(!this.props.isInExperience && !this.props.channelId){
      Actions.fetchExperiences();
      Actions.fetchChannels();
    }
  },

  componentDidMount : function(){
    $('body').on("influitive:challenge-rejected", this._onLaterChallengeEvent);
    $('body').on("influitive:challenge-completed", this._onCompletedChallenge);
    $('body').on("influitive:waiting-confirmation", this._onWaitingChallenge);
    this.props.appNotificationCenter
      .subscribe('infl:possible_targeting_change', this.handleTargetingChange);
  },

  handleTargetingChange() {
    challengeUnlock.refresh(this.props).then(challenges => {
      this.setState({ unlockedChallenges: challenges });
    });
  },

  componentDidUpdate : function(_prevProps, prevState){
    if (!prevState.data.challengeListLoaded && this.state.data.challengeListLoaded) {
      mobile.iosInflunet.challengeListLoaded();
    }

    if (
      !this.state.data.hasMoreChallenges &&
      !this.state.data.unlockableChallengesListLoaded &&
      this._showUnlockableChallenges()
    ) {
      this._fetchChallenges('fetchUnlockableChallenges');
    }

    var tabsChanged     = (this.state.selectedTabIndex !== prevState.selectedTabIndex);
    var filterChanged   = (this.state.selectedChallengeFilter !== prevState.selectedChallengeFilter);

    this._refreshPage = (tabsChanged || filterChanged);
  },

  render: function() {
    return (
      <div className={`challenge-browser' ${this.state.selectedTabName.replace(/ |'/g, '')}`}>
        <ChallengesUnlocked
          channel={this.props.currentChannel}
          unlockedChallenges={this.state.unlockedChallenges}
          fetchUnlockedChallenges={this._handleUnlockNoticeClick} />

        {this.props.currentExperience.isSelected || this.props.channelId ? this._experienceHeader() : this._regularHeader()}

        <ChallengeError
          errors={this.state.data.errors}
          fetchChallenges={this._fetchChallenges}
          fetchAction={this._challengeActionsConfig().stages[this.state.selectedTabIndex].action} />

        <ChallengesLoading
          loadingChallenges={this.state.data.loadingChallenges}
          experienceCount={this.state.data.experiences.length}
          challengeStage={this._challengeActionsConfig().stages[this.state.selectedTabIndex].code} />

        <h2 className="sr-only">{this.props.t('List of the last challenges')}</h2>
        <div id="mdew-wn-content"></div>

        <ChallengeCards
          challenges={this.state.data.challenges}
          loadingChallenges={this.state.data.loadingChallenges}
          hasMoreChallenges={this.state.data.hasMoreChallenges}
          hideCounters={this.state.data.hideCounters}
          experiences={this.state.data.experiences}
          channels={this.state.data.channels}
          challengeActions={this._challengeActionsConfig().actions}
          challengeStage={this._challengeActionsConfig().stages[this.state.selectedTabIndex].code}
          experiencePath={this.props.experiencePath}
          channelPath={this.props.channelPath}
          fetchNextPageOfResults={this._fetchNextPageOfResults}
          didTabsChange={this._refreshPage}
          retrieveChallengeStatusDescription={this._retrieveChallengeStatusDescription}
          challengeStatusDescription={this.state.data.challengeStatusDescription}
          pageThreshold={this.props.pageThreshold}
          homepageUrl={this.props.homepageUrl}
          shortCardDesignEnabled={this.props.shortCardDesignEnabled} />

        {!this.state.data.hasMoreChallenges && this._hasChallenges() &&
         this._showUnlockableChallenges() && this._hasUnlockableChallenges() &&
          <div className='unlockable-challenges'>
            <h3 className='header'>{this.props.t('Unlockable Challenges')}</h3>
            <p>{this.props.t('Complete the above challenges to unlock these below!')}</p>
            <ChallengeCards
              challenges={this.state.data.unlockableChallenges}
              isUnlockable={true}
              loadingChallenges={this.state.data.loadingUnlockableChallenges}
              hasMoreChallenges={this.state.data.hasMoreUnlockableChallenges}
              experiences={[]}
              channels={[]}
              challengeActions={this._challengeActionsConfig().actions}
              challengeStage={this._challengeActionsConfig().stages[this.state.selectedTabIndex].code}
              fetchNextPageOfResults={this._fetchNextPageOfUnlockableResults}
              didTabsChange={this._refreshPage}
              retrieveChallengeStatusDescription={this._retrieveChallengeStatusDescription}
              challengeStatusDescription={this.state.data.challengeStatusDescription}
              pageThreshold={this.props.pageThreshold}
              shortCardDesignEnabled={this.props.shortCardDesignEnabled} />
          </div>
        }

        <NoChallenges
          systemAvailability={this.props.systemAvailability}
          advocateRewardsPath={this.props.advocateRewardsPath}
          editProfilePath={this.props.editProfilePath}
          hasChallenges={this._hasChallenges()}
          loadingChallenges={this.state.data.loadingChallenges}
          channelCount={this.state.data.channels.filter(c => c.total_challenge_count).length}
          experienceCount={this.state.data.experiences.length}
          changeTab={this._changeTab}
          stages={this._challengeActionsConfig().stages}
          challengeStage={this._challengeActionsConfig().stages[this.state.selectedTabIndex].code} />
        <div id="mdew-wn-content-bottom"></div>
      </div>
    );
  },

  _experienceHeader : function(){
    var currentObject = this.props.currentExperience;
    if(this.props.channelId && Object.keys(this.props.currentChannel).length > 0) {
      currentObject = this.props.currentChannel;
    }
    return (
    <ExperienceHeader
      communityName={this._communityName()}
      url={this._returnUrl()}
      selectedTabIndex={this.state.selectedTabIndex}
      onTabChange={this._changeTab}
      challengeStages={this._challengeActionsConfig().stages}
      currentObject={currentObject}
      onFilterChange={this._applyFilter}
      challengeTypes={this.state.data.challengeTypes}
      selectedChallengeFilter={this.state.selectedChallengeFilter} />
  )},

  _returnUrl : function() {
    var redirectParam = '';
    if (!this.props.channelId && this.props.experienceReturnUrl) {
      redirectParam = `?r=${encodeURIComponent(this.props.experienceReturnUrl)}`;
    }
    return this.props.homepageUrl + redirectParam;
  },

  _communityName : function() {
    if (!this.props.channelId && this.props.communityName) {
      return this.props.communityName;
    }
    return 'Challenges';
  },

  _regularHeader : function(){
    return (
      <RegularHeader
          selectedTabIndex={this.state.selectedTabIndex}
          onTabChange={this._changeTab}
          onFilterChange={this._applyFilter}
          challengeTypes={this.state.data.challengeTypes}
          selectedChallengeFilter={this.state.selectedChallengeFilter}
          challengeStages={this._challengeActionsConfig().stages} />)
  },

  _hasChallenges : function(){
    var hasChallenges = false;
    for(var i = 0; i < this.state.data.challenges.length; i++){
      if(this.state.data.challenges[i].length > 0){
        hasChallenges = true;
      }
    }
    return hasChallenges;
  },

  _hasUnlockableChallenges: function() {
    return _.any(this.state.data.unlockableChallenges, function(page) {
      return _.gt(page.length, 0);
    });
  },

  _challengeActionsConfig : function(){
    var config = {
      stages : [
        { title: this.props.t('Available'), action: 'fetchAvailableChallenges', code: 'Available' },
        { title: this.props.t('Pending Approval'),   action: 'fetchWaitingChallenges',   code: 'Waiting' },
        { title: this.props.t('Later'),     action: 'fetchLaterChallenges',     code: 'Later' },
        { title: this.props.t('Completed'), action: 'fetchCompletedChallenges', code: 'Completed' }
      ],
      actions : {
        view: this._viewChallenge,
        later : this._laterChallenge,
        challengeType: this._challengeTypeSelect,
        makeAvailable : this._makeChallengeAvailable,
        markAsSeen: this._markAsSeen
      }
    };

    if (window._infl.hub.features.includes('mountain_dew')) {
      config.stages.unshift({ title: 'What\'s New', action: 'fetchNewestChallenges', code: 'Newest' });
      config.stages[1] = { title: this.props.t('Available'), action: 'fetchAvailableChallenges', code: 'Available' };
    }
    return config;
  },

  _onCompletedChallenge : function(event, data){
    this._animateTabTitle("completed");
    this._hideChallengeCard(data.challengeId);
  },

  _onWaitingChallenge : function(event, data){
    this._animateTabTitle("waiting");
    this._hideChallengeCard(data.challengeId);
  },

  _hideChallengeCard : function(cardId){
    var cardIdInt = parseInt(cardId, 10);

    this.setState({
      data: {
        ...this.state.data,
        challenges: _.map(this.state.data.challenges, function(cs) {
          return _.reject(cs, {id: cardIdInt});
        })
      }
    });
  },

  _markAsSeen: function(challengeId) {
    this.setState({
      data: {
        ...this.state.data,
        challenges:
          _.map(this.state.data.challenges, challenges =>
            _.map(challenges, challenge =>
              challenge.id === challengeId
                ? { ...challenge, unseen: false }
                : challenge
            )
          )
      }
    });
  },

  _handleUnlockNoticeClick : function(unlock) {
    challengeUnlock.reset();
    this._resetUnlockableChallenges();
    if(this.props.currentChannel && this.props.currentChannel.id) {
      this._fetchUnlockedChallenges(unlock.challenge_ids);
    } else if(this.props.currentExperience.id === unlock.experience_id) {
      this._fetchUnlockedChallenges(unlock.challenge_ids);
      Actions.fetchChannels();
    } else {
      ExperiencesActions.showExperience(unlock.experience_id);
    }
  },

  _fetchUnlockedChallenges : function(challenge_ids){
    var sort = this.state.selectedChallengeFilter.sort;
    Actions.fetchUnlockedChallenges(sort, challenge_ids);
    if (window._infl.hub.features.includes('mountain_dew')) {
      this.setState({
        data : {
          challenges : [[]],
          challengeTypes : [],
          experiences : [],
          channels : [],
          hasMoreChallenges : false,
          loadingChallenges : true,
          errors : null
        },
        showChallengeUnlocked : false,
        unlockedChallenges : [],
        selectedTabIndex : 1,
        selectedTabName : this._currentTabName(1),
        selectedChallengeFilter: {
          type: "",
          sort: ""
        }
      })
    } else {
      this.setState({
        showChallengeUnlocked : false,
        unlockedChallenges : [],
        selectedTabIndex : 0
      });
    }

  },

  _onChallengeUnlocked : function(unlockedChallenges){
    this.setState({
      unlockedChallenges
    });
  },

  _laterChallenge : function(challenge){
    Actions.laterChallenge(challenge.id, this.props.csrf_token);

    this._animateCardRemove(challenge.id);
    this._animateTabTitle("later");

    app.analytics.logEvent('Challenge Card Action', {challengeId: challenge.id, action: 'later'});
  },

  _animateCardRemove : function(challengeId){
    var challengeCard = document.getElementById("challenge-" + challengeId);

    animate.run(challengeCard, "shrink", false, function(element){
      $(element).css("visibility", "hidden");
      animateCardReshuffle.run(challengeId, element);
    });
  },

  _animateTabTitle : function(tabTitleToAnimate){
    var $tabTitle = $(".pt-tabs-menu #challenge-stage-" + tabTitleToAnimate + " a span");
    animate.run($tabTitle, "bounce");
  },

  _viewChallenge : function(challenge, source, tab){
    var tab = tab.toLowerCase();

    this.props.viewChallenge.open(challenge, this.state.selectedChallengeType, "cell", tab);

    app.analytics.logEvent('Challenge Card Action', {challengeId: challenge.id, action: 'view', source: source});
  },

  _onLaterChallengeEvent : function(){
    Actions[this._challengeActionsConfig().stages[this.state.selectedTabIndex].action]();
  },

  _makeChallengeAvailable : function(challenge){

  },

  _applyFilter: function(action, options) {
    var currentFilter = this.state.selectedChallengeFilter;
    var newFilter     = _.merge({}, currentFilter, options);

    this.setState({ selectedChallengeFilter : newFilter }, function () {
      this._fetchChallenges(action);
    });
  },

  _changeTab: function(action, tabIndex) {
    const tabName = this._currentTabName(tabIndex);
    this.setState({
      data : {
        challenges : [[]],
        challengeTypes : [],
        experiences : [],
        channels : [],
        hasMoreChallenges : false,
        loadingChallenges : true,
        errors : null
      },
      selectedTabIndex : tabIndex,
      selectedTabName : tabName,
      selectedChallengeFilter: {
        type: "",
        sort: ""
      }
    }, function(){
      app.analytics.logEvent(`HomepageChallengeFilter::${tabName.toUpperCase().replace(/ /g,"_").toLowerCase}_CLICKED`);
      this._fetchChallenges(action);
    });
  },

  _fetchNextPageOfResults : function(pageNumber){
    this._fetchChallenges(this._challengeActionsConfig().stages[this.state.selectedTabIndex].action, pageNumber);
  },

  _fetchNextPageOfUnlockableResults: function(pageNumber) {
    this._fetchChallenges('fetchUnlockableChallenges', pageNumber);
  },

  _fetchChallenges : function(action, pageNumber) {
    var filter = this.state.selectedChallengeFilter.type;
    var sort   = this.state.selectedChallengeFilter.sort;
    Actions[action](filter, sort, pageNumber);
  },

  _currentTabName: function (tabIndex) {
    var tabObj = this._challengeActionsConfig().stages[tabIndex];
    return tabObj.title.toLowerCase();
  },

  _challengeTypeSelect: function(challengeTypeName) {
    var selectedChallengeType = _.find(this.state.data.challengeTypes, function(challengeType) {
      return (challengeTypeName === challengeType.name);
    });

    var action = this._challengeActionsConfig().stages[this.state.selectedTabIndex].action;

    var currentFilter = this.state.selectedChallengeFilter;
    var newFilter     = _.merge({}, currentFilter, { type: selectedChallengeType.filter });

    app.analytics.logEvent('Challenges Filtering', {filteringOption: newFilter.type});

    this.setState({ selectedChallengeFilter : newFilter }, function () {
      this._fetchChallenges(action);
    });
  },

  _retrieveChallengeStatusDescription: function(challengeId, statusType) {
    Actions.retrieveChallengeStatusDescription(challengeId, statusType);
  },

  _resetUnlockableChallenges: function() {
    this.setState({
      data: {
        ...this.state.data,
        unlockableChallengesListLoaded: false,
        unlockableChallenges: [[]]
      }
    });
  },

  _showUnlockableChallenges: function() {
    return window && window._infl &&
      window._infl.hub && window._infl.hub.features &&
      window._infl.hub.features.includes('show_unlockable_challenges') || false;
  }
});

module.exports = withNamespaces('HubFE')(ChallengeBrowser);



// WEBPACK FOOTER //
// ./src/advocate/challenges/browser.jsx